import { makeAutoObservable, runInAction } from "mobx";
import { LoginUser, User } from "../models/user";
import axios from "axios";
import { store } from "./store";
import { router } from "../router/routes";

export default class UserStore {
    user: User | null = null;

    baseUrl: string = process.env.REACT_APP_API_URL + 'admin/login';
    userUrl: string = process.env.REACT_APP_API_URL + 'getuser';

    constructor() {
        makeAutoObservable(this);
    }

    get isLoggedIn() {

        return !!this.user;
    }

    login = async (creds: LoginUser) => {
        try {

            var response = await axios.post(this.baseUrl, creds);
            store.commonStore.setToken(response.data.token);

            runInAction(() => {
                this.user = {} as User;
                this.user!.username = response.data.userName;
                this.user!.token = response.data.token;

                router.navigate('/admin/admindashboard');
            });
        } catch (error) {

            throw error;
        }
    }

    logout = () => {
        store.commonStore.setToken(null);
        this.user = null;
        router.navigate('/');
    }

    getUser = async () => {
        try {

            axios.interceptors.request.use(config => {
                const token = store.commonStore.token;
                if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;

                return config;
            });

            const response = await axios.get(this.userUrl);

            runInAction(() => {
                this.user = {} as User;
                this.user!.username = response.data.userName;
                this.user!.token = response.data.token;
            });
        } catch (error) {

        }
    }

}